import React, { useState, useEffect, useRef } from 'react';
import '../../../Styles/Styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import CssClass from "../../../Styles/common.module.css";
import BackModal from '../../../Components/BasicElements/BackModal';
import ConfirmModal from '../../../Components/BasicElements/ConfirmModal';
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import * as Comp from "../../../Common/CommonComponents";
import { differenceInYears, differenceInMonths, differenceInDays, format } from 'date-fns';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const EmployeeUpdate = (props) => {
  //#region React Hooks
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
	const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading....");
  const [workTypeChanged, setWorkTypeChanged] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [showUpdateEntitlement, setShowUpdateEntitlement] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [deptList, setDeptList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [workTypeList, setWorkTypeList] = useState([]);
  const [originalEntitlementList, setOriginalEntitlementList] = useState([]);
  const [userEntitlementList, setUserEntitlementList] = useState([]);
  const [selectedDept, setSelectedDept] = useState([]);
  const [selectedRole, setSelectedRole] = useState([]);
  const [selectedWorkType, setSelectedWorkType] = useState([]);
  const [editData, setEditData] = useState([]);
  const [editEntitlementData, setEditEntitlementData] = useState([]);
  const [inputError, setInputError] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(3);

  useEffect(() => {
    if (props.editData !== null) {
      setEditData({
        USER_ID: props.editData.USER_ID === null ? "" : props.editData.USER_ID,
        USERNAME: props.editData.USERNAME === null ? "" : props.editData.USERNAME,
        EMAIL: props.editData.EMAIL === null ? "" : props.editData.EMAIL,
        DEPT_ID: props.editData.DEPT_ID === null ? "" : props.editData.DEPT_ID,
        ROLE_ID: props.editData.ROLE_ID === null ? "" : props.editData.ROLE_ID,
        WORK_TYPE: props.editData.WORK_TYPE === null ? "" : props.editData.WORK_TYPE,
        SERVICE_STARTDATE: props.editData.SERVICE_STARTDATE === null ? "" : props.editData.SERVICE_STARTDATE,
        SERVICE_ENDDATE: props.editData.SERVICE_ENDDATE < props.editData.SERVICE_STARTDATE ? "" : props.editData.SERVICE_ENDDATE,
        ANNUAL_LEAVE_ENTITLED: props.editData.ANNUAL_LEAVE_ENTITLED === null ? "" : props.editData.ANNUAL_LEAVE_ENTITLED,
        MEDICAL_LEAVE_ENTITLED: props.editData.MEDICAL_LEAVE_ENTITLED === null ? "" : props.editData.MEDICAL_LEAVE_ENTITLED,
        MEDICAL_LEAVE_CLAIM: props.editData.MEDICAL_LEAVE_CLAIM === null ? "" : props.editData.MEDICAL_LEAVE_CLAIM,
      })
    }
  }, [props.editData]);
  //#endregion

  function calculateServicePeriod(startDateStr, endDateStr) {
    if (!startDateStr) return "";

    const startDate = new Date(startDateStr);
    let endDate = endDateStr && endDateStr.trim?.() !== "" ? new Date(endDateStr) : new Date();
  
    const years = differenceInYears(endDate, startDate);
    const afterYears = new Date(startDate);
    afterYears.setFullYear(afterYears.getFullYear() + years);
  
    const months = differenceInMonths(endDate, afterYears);
    const afterMonths = new Date(afterYears);
    afterMonths.setMonth(afterMonths.getMonth() + months);
  
    const days = differenceInDays(endDate, afterMonths);
  
    const yearText = `${years} year${years !== 1 ? "s" : ""}`;
    const monthText = `${months} month${months !== 1 ? "s" : ""}`;
    const dayText = `${days} day${days !== 1 ? "s" : ""}`;
  
    return `${yearText}, ${monthText}, ${dayText}`;
  }
  
  useEffect(() => {
    const period = calculateServicePeriod(editData.SERVICE_STARTDATE, editData.SERVICE_ENDDATE);
    setEditData((prev) => ({
      ...prev,
      SERVICE_PERIOD: period,
    }));
  }, [editData.SERVICE_STARTDATE, editData.SERVICE_ENDDATE]);

  //#region useEffect to get dept list 
  useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get Dept List";
			http
			  .get("api/profile/GetDeptList?_sysUser=" + userId, { timeout: 100000 })
			  .then((response) => {
				const listItems = response.data.map(dept => ({
					key: dept.DEPT_ID,
					value: dept.DEPT_ID,
					label: `${dept.DEPT_NAME}`
				}));
				setDeptList(listItems);
			})
			.catch((err) => {
				toast.error("Error on getting dept list. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			})
		} catch (err) {
			toast.error("Error on getting dept list. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
  }, []);

  useEffect(() => {
    if (deptList.length > 0 && props.editData !== null && props.editData.DEPT_ID) {
      const matchedDept = deptList.find(dept => dept.value === props.editData.DEPT_ID);
      if (matchedDept) {
        setSelectedDept(matchedDept);
      }
    }
  }, [deptList, props.editData]);
  //#endregion

  //#region useEffect to get role list 
  useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get Role List";
			http
			  .get("api/profile/GetRoleList?_sysUser=" + userId, { timeout: 100000 })
			  .then((response) => {
				const listItems = response.data.map(role => ({
					key: role.ROLE_ID,
					value: role.ROLE_ID,
					label: `${role.ROLE_NAME}`
				}));
				setRoleList(listItems);
			})
			.catch((err) => {
				toast.error("Error on getting user role list. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			})
		} catch (err) {
			toast.error("Error on getting user role list. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
  }, []);

  useEffect(() => {
    if (roleList.length > 0 && props.editData !== null && props.editData.ROLE_ID) {
      const roleIds = typeof props.editData.ROLE_ID === "string"
        ? props.editData.ROLE_ID.split(',').map(id => id.trim())
        : Array.isArray(props.editData.ROLE_ID)
          ? props.editData.ROLE_ID
          : [];

      const matchedRoles = roleList.filter(role => roleIds.includes(role.value));
      setSelectedRole(matchedRoles);
    }
  }, [roleList, props.editData]);
  //#endregion

  //#region useEffect to get work type list 
  useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get Work Type List";
			http
			  .get("api/profile/GetWorkTypeList?_sysUser=" + userId, { timeout: 100000 })
			  .then((response) => {
				const listItems = response.data.map(workType => ({
					key: workType.CATEGORY_TYPE_MST_ID,
					value: workType.CATEGORY_TYPE_MST_ID,
					label: `${workType.CATEGORY_TYPE_NAME}`
				}));
				setWorkTypeList(listItems);
			})
			.catch((err) => {
				toast.error("Error on getting work type list. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			})
		} catch (err) {
			toast.error("Error on getting work type list. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
  }, []);

  useEffect(() => {
    if (workTypeList.length > 0 && props.editData !== null && props.editData.WORK_TYPE) {
      const matchedWorkType = workTypeList.find(workType => workType.value === props.editData.WORK_TYPE);
      if (matchedWorkType) {
        setSelectedWorkType(matchedWorkType);
      }
    }
  }, [workTypeList, props.editData]);
  //#endregion

  //#region useEffect to get user entitlement 
  useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get User Entitlement";
			const userIds = editData.USER_ID;
			const listItems = [];
			http
			  .get("api/profile/GetUserEntitlement?_sysUser=" + userIds, { timeout: 100000 })
			  .then((response) => {
				if (response.data.length > 0) {
					response.data.forEach((data) => {
            listItems.push({
              key: data.USER_ENTITLEMENT_ID,
              USER_ENTITLEMENT_ID: data.USER_ENTITLEMENT_ID,
              CATEGORY_TYPE_MST_ID: data.CATEGORY_TYPE_MST_ID,
              CATEGORY_DESC: data.CATEGORY_DESC,
              CATEGORY_TYPE_NAME: data.CATEGORY_TYPE_NAME,
              ENTITLEMENT: data.ENTITLEMENT ?? '0',
            });
          });
				}
				setUserEntitlementList(listItems);
				setOriginalEntitlementList(listItems);
			})
			.catch((err) => {
				toast.error("Error on getting user entitlement. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			})
		} catch (err) {
			toast.error("Error on getting user entitlement. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
  }, [editData.USER_ID]);
  //#endregion
  
  //#region useEffect to get leave entitlement
  useEffect(() => {
    if (!workTypeChanged) return;

    if (selectedWorkType?.value === 'EF9A209D-1484-4A8B-817D-771A6715940C') {
      setUserEntitlementList(originalEntitlementList);
      return;
    }

    let functionName = "";
    try {
      functionName = "Get Leave Entitlement";
      const workType = selectedWorkType?.key || "";
      const startDateStr = editData.SERVICE_STARTDATE || "";
      const endDateStr = editData.SERVICE_ENDDATE || "";
      let totalYears = '';
      const listItems = [];
  
      if (startDateStr) {
        const startDate = new Date(startDateStr);
        let endDate = new Date();

        if (endDateStr && new Date(endDateStr) > startDate) {
          endDate = new Date(endDateStr);
        }

        totalYears = differenceInYears(endDate, startDate);
      }
  
      http
        .get("api/profile/GetLeaveEntitlement?_sysUser=" + userId
            + "&_workType=" + workType
            + "&_totalYears=" + totalYears
            + "&_serviceDate=" + startDateStr, 
            { timeout: 100000 })
        .then((response) => {
        if (response.data.length > 0) {
          response.data.forEach((data) => {
            const existingEntitlement = originalEntitlementList.find(x => 
              x.CATEGORY_TYPE_MST_ID === data.CATEGORY_TYPE_MST_ID &&
              x.CATEGORY_DESC === data.CATEGORY_DESC
            );
            
            listItems.push({
              key: data.CATEGORY_TYPE_MST_ID,
              USER_ENTITLEMENT_ID: existingEntitlement?.USER_ENTITLEMENT_ID || null,
              CATEGORY_TYPE_MST_ID: data.CATEGORY_TYPE_MST_ID,
              CATEGORY_DESC: data.CATEGORY_DESC,
              CATEGORY_TYPE_NAME: data.CATEGORY_TYPE_NAME,
              ENTITLEMENT: data.ENTITLEMENT ?? '0',
            });
          });
        }
        setUserEntitlementList(listItems);
      })
      .catch((err) => {
        toast.error("Error on getting leave entitlement. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      })
    } catch (err) {
      toast.error("Error on getting leave entitlement. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }, [workTypeChanged, selectedWorkType, editData.SERVICE_STARTDATE, editData.SERVICE_ENDDATE]);
  //#endregion

  //#region Save Edit
  function saveEditUser() {
    let functionName = "";
    try {
      functionName = saveEditUser.name;
      setLoading(true, "Updating user, Please wait....");
      const selectedDepts = selectedDept?.key || "";
      const selectedRoles = selectedRole.map(r => r.key);
      const selectedWorkTypes = selectedWorkType?.key || "";
      
      const data = {
        USER_MST_GUID: editData.USER_ID,
        USERNAME: editData.USERNAME,
        EMAIL: editData.EMAIL,
        DEPT_ID: selectedDepts,
        USER_ROLE_LIST: selectedRoles,
        EMPLOYMENT_STATUS: selectedWorkTypes,
        SERVICE_STARTDATE: editData.SERVICE_STARTDATE,
        SERVICE_ENDDATE: selectedWorkTypes === 'EF9A209D-1484-4A8B-817D-771A6715940C' ? editData.SERVICE_ENDDATE : null,
        ACTIVE_FLAG: "Y", 
        ENTITLEMENT_LIST: userEntitlementList,
        UPDATE_ID: userId,
        FROM_SOURCE: {SOURCE: "WEB", MODULE_ID: props.module },
      };
      http
        .post("api/profile/EmployeeUpdate", data, { timeout: 10000})
        .then((response) => {
          toast.success("User is successfully Updated.");
					props.onReload();
        })
        .catch((err) => {
          toast.error("Failed to update user. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
    } catch (err) {
      toast.error("Failed to update user. Please try again.....(receive)");
      common.c_LogWebError(props.page, functionName, err);
    }
  };
  //#endregion

	const inputRequiredHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;
    
		if (val.length === 0 || val.trim().length === 0) {
			setInputError((prevState) => ({
				...prevState,
				[id]: `${name} could not be empty.`,
			}));
		} else {
			setInputError((prevState) => ({
				...prevState,
				[id]: "",
			}));
		}

		if (id === "SERVICE_ENDDATE") {
      if (selectedWorkType?.label === "Resigned") {
        if (val.length === 0 || val.trim().length === 0) {
          setInputError((prevState) => ({
            ...prevState,
            [id]: `${name} could not be empty.`,
          }));
        } else {
          setInputError((prevState) => ({
            ...prevState,
            [id]: "",
          }));
        }
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
		}
		setEditData((prevState) => ({
			...prevState,
			[id]: val,
		}));

		setHasChanges(true);
  }

  const inputEntitlementRequiredHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;
    
    const categoryType = editEntitlementData?.CATEGORY_TYPE_MST_ID;
    const decimalPattern = categoryType === "46E44004-B5D3-4702-A188-3C09A6F663A9" 
      ? /^(0|[1-9]\d*)(\.\d{0,2})?$/
      : categoryType === "D80DF667-D6BF-43AA-93A1-441C99663C04"
        ? /^(0|[1-9]\d*)$/
        : /^(0|[1-9]\d*)(\.\d{0,1})?$/;

    const isValid = val === "" || decimalPattern.test(val);

		if (val.length === 0 || val.trim().length === 0) {
			setInputError((prevState) => ({
				...prevState,
				[id]: `${name} could not be empty.`,
			}));
		} else if (!isValid) {
      return;
    } else {
			setInputError((prevState) => ({
				...prevState,
				[id]: "",
			}));
		}
		setEditEntitlementData((prevState) => ({
			...prevState,
			[id]: val,
		}));
  }

  const inputUnrequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputUnrequiredHandler.name;
      const id = event.target.id;
      const val = event.target.value;

      furtherValidateInput(id, val);
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
    setHasChanges(true);
  }

  function furtherValidateInput(id, val) {
    if (id === "EMAIL") {
      if (!common.EMAIL_REGEX.test(val) && val !== "") {
        setInputError((prevState) => ({
          ...prevState,
          [id]: ("Please enter a proper email."),
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: (""),
        }));
      }
    }
  }
  
  const selectDeptHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectDeptHandler.name;
      if (val && Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          DEPT: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          DEPT: "Department could not be empty.",
        }));
      }
      setSelectedDept(val);
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
    setHasChanges(true);
  }
  
  const selectRoleHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectRoleHandler.name;
      if (val && val.length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          ROLE: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          ROLE: "Role could not be empty.",
        }));
      }
      setSelectedRole(val);
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
    setHasChanges(true);
  }
  
  const selectWorkTypeHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectWorkTypeHandler.name;
      if (val && Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          WORK_TYPE: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          WORK_TYPE: "Work type could not be empty.",
        }));
      }
      setInputError((prevState) => ({
        ...prevState,
        SERVICE_ENDDATE: "",
      }));
      setSelectedWorkType(val);
      setWorkTypeChanged(true);

    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
    setHasChanges(true);
  }

	//#region Event handle
	const hideModal = () => {
    setEditData([]);
    setInputError([]);
    setSelectedDept([]);
    setSelectedRole([]);
    setSelectedWorkType([]);
    setEditEntitlementData([]);
		setHasChanges(false);
    setWorkTypeChanged(false);
    props.onHide();
  };

	const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
    setUserEntitlementList(originalEntitlementList);
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

  const handleConfirm = () => {
		var flag = true;

    if (selectedWorkType?.label === "Resigned" && editData.SERVICE_ENDDATE === null) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				SERVICE_ENDDATE: ("Service End Date could not be empty."),
			}));
    }
    
    if (Object.values(inputError).filter(v => v !== "").length === 0 && flag) {
    	setShowConfirmModal(true);
    }
  };

  const handleConfirmModal = () => {
    saveEditUser();
    setShowConfirmModal(false); // Hide confirm modal
    hideModal();
  };

  const handleConfirmModalClose = () => {
    setShowConfirmModal(false); // Hide back modal on cancel
  };

  const showUpdateEntitlementModal = (e, rowData) => {
    setShowUpdateEntitlement(!showUpdateEntitlement);
    setEditEntitlementData(rowData);
  };

  const hideUpdateEntitlementModal = () => {
    setShowUpdateEntitlement(!showUpdateEntitlement);
    setEditEntitlementData(null);
    setInputError([]);
  };
  
  const handleEntitlementBack = () => {
		hideUpdateEntitlementModal();
	};

  const handleEntitlementConfirm = () => {
    const updatedList = userEntitlementList.map((item) =>
      item.CATEGORY_TYPE_MST_ID === editEntitlementData.CATEGORY_TYPE_MST_ID &&
      item.CATEGORY_DESC === editEntitlementData.CATEGORY_DESC
        ? { ...item, ENTITLEMENT: editEntitlementData.ENTITLEMENT }
        : item
    );

    setUserEntitlementList(updatedList);
    setShowUpdateEntitlement(!showUpdateEntitlement);
    setEditEntitlementData(null);
		setHasChanges(true);
  };
	//#endregion

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered size="lg" className="employeeModal">
        <Modal.Header>
          <div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
            <Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Edit</Modal.Title>
          </div>
        </Modal.Header>
    
        <Modal.Body>
          <div style={{ marginBottom: "15px" }}>
            <h5>Personal Details</h5>
            <hr />
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="USERNAME"
                  label="Name*"
                  name="Username"
                  type="text"
                  className="form-control"
                  errorMessage={inputError.USERNAME}
                  value={editData.USERNAME}
                  onChange={inputRequiredHandler}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="EMAIL"
                  label="Email*"
                  name="Email"
                  type="text"
                  className="form-control"
                  errorMessage={inputError.EMAIL}
                  value={editData.EMAIL}
                  onChange={inputUnrequiredHandler}
                />
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Comp.Select
                  id="DEPT"
                  label="Department*"
                  type="text"
                  options={deptList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  errorMessage={inputError.DEPT}
                  value={selectedDept}
                  onChange={selectDeptHandler}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Comp.Select
                  id="ROLE"
                  label="Role*"
                  type="text"
                  options={roleList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  errorMessage={inputError.ROLE}
                  value={selectedRole}
                  onChange={selectRoleHandler}
                  isMulti
                  isClearable
                />
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Comp.Select
                  id="WORK_TYPE"
                  label="Work Type*"
                  type="text"
                  options={workTypeList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  errorMessage={inputError.WORK_TYPE}
                  value={selectedWorkType}
                  onChange={selectWorkTypeHandler}
                />
              </div>
              <div style={{ flex: 1 }}>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="SERVICE_STARTDATE"
                  label="Service Start Date*"
                  name="Service Start Date"
                  type="date"
                  className="form-control"
                  errorMessage={inputError.SERVICE_STARTDATE}
                  value={editData.SERVICE_STARTDATE ? editData.SERVICE_STARTDATE.slice(0, 10) : ""}
                  onChange={inputRequiredHandler}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="SERVICE_ENDDATE"
                  label={`Service End Date${selectedWorkType?.label === "Resigned" ? "*" : ""}`}
                  name="Service End Date"
                  type="date"
                  className="form-control"
                  errorMessage={inputError.SERVICE_ENDDATE}
                  value={selectedWorkType?.label === "Resigned" ? editData.SERVICE_ENDDATE ? editData.SERVICE_ENDDATE.slice(0, 10) : "" : ""}
                  onChange={inputRequiredHandler}
                  disabled={selectedWorkType?.label !== "Resigned"}
                />
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="SERVICE_PERIOD"
                  label="Service Period"
                  name="Service Period"
                  type="text"
                  className="form-control"
                  value={editData.SERVICE_PERIOD}
                  readOnly
                />
              </div>
              <div style={{ flex: 1 }}>
              </div>
            </div>
          </div>
          <div>
            <h5>Leave Entitlements</h5>
            <hr />
            <div style={{ width: "100%", marginBottom: "15px" }}>
              <DataTable value={userEntitlementList} dataKey="USER_ENTITLEMENT_ID" className="datatable">
                <Column header="Action"
                  style={{ width: '30px' }}
                  body={(rowData) => (
                    <div style={{ textAlign: "-webkit-center" }} className={CssClass.tdBtnActionWrapperTwo}>
                      <span title="Modify">
                        <Comp.Button
                          id="btnEdit"
                          type="general"
                          onClick={(e) => showUpdateEntitlementModal(e, rowData)}
                          style={{ width: "55px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
                        >
                          <FontAwesomeIcon icon={faPenToSquare} />
                        </Comp.Button>
                      </span>
                    </div>
                  )}
                />
                <Column
                  header="#"
                  body={(rowData, options) => options.rowIndex + 1 + currentPage * rowsPerPage}
                  style={{ width: '1rem', textAlign: 'center' }}
                />
                <Column header="Category" field="CATEGORY_DESC" style={{ width: '12rem' }}></Column>
                <Column header="Type" field="CATEGORY_TYPE_NAME" style={{ width: '12rem' }}></Column>
                <Column 
                  header="Entitlement" 
                  field="ENTITLEMENT" 
                  style={{ width: '12rem' }}
                  body={(data) => 
                    (data.CATEGORY_TYPE_MST_ID === '46E44004-B5D3-4702-A188-3C09A6F663A9') 
                      ? `RM ${data.ENTITLEMENT}` 
                      : `${data.ENTITLEMENT} days`
                  }
                />
              </DataTable>
            </div>
          </div>
        </Modal.Body>
    
        <Modal.Footer>
          <div className="onright-container">
            <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={handleBack}
            >
              <FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
            </Comp.Button>
                
            <Comp.Button id="btnSave" onClick={handleConfirm}>
              <FontAwesomeIcon icon={faCheck} />&nbsp; Save
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={showUpdateEntitlement} onHide={hideUpdateEntitlementModal} centered size="sg">
        <Modal.Header>
          <div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
            <Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Edit Leave Entitlement</Modal.Title>
          </div>
        </Modal.Header>
    
        <Modal.Body>
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="CATEGORY_DESC"
                  label="Category"
                  name="Category"
                  type="text"
                  className="form-control"
                  value={editEntitlementData?.CATEGORY_DESC}
                  readOnly
                />
              </div>
              <div style={{ flex: 1 }}>
                <Comp.Input
                  id="CATEGORY_TYPE_NAME"
                  label="Type"
                  name="Type"
                  type="text"
                  className="form-control"
                  value={editEntitlementData?.CATEGORY_TYPE_NAME}
                  readOnly
                />
              </div>
            </div>

            <Comp.Input
              id="ENTITLEMENT"
              label="Entitlement*"
              name="Entitlement"
              type="text"
              className="form-control"
              errorMessage={inputError.ENTITLEMENT}
              value={editEntitlementData?.ENTITLEMENT}
              onChange={inputEntitlementRequiredHandler}
            />
          </div>
        </Modal.Body>
    
        <Modal.Footer>
          <div className="onright-container">
            <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={handleEntitlementBack}
            >
              <FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
            </Comp.Button>
                
            <Comp.Button id="btnSave" onClick={handleEntitlementConfirm}>
              <FontAwesomeIcon icon={faCheck} />&nbsp; Save
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal */}
      <BackModal
        show={showBackModal}
        onHide={handleConfirmBackCancel}
        onConfirm={handleConfirmBack}
        prop="Confirm Navigation"
      >
        Are you sure you want to go back? Your changes may be lost.
      </BackModal>

      <ConfirmModal
        show={showConfirmModal}
        onHide={handleConfirmModalClose}
        onConfirm={handleConfirmModal}
			  prop="Confirm to save"
      >
        Are you sure you want to update employee?
      </ConfirmModal>

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default EmployeeUpdate;
